import {defineStore} from 'pinia';
import {ModuleDataManagementList} from '@/stores/moduleConst';


const action = {
  setMessage(message) {
    this.database_id = message.DatabaseId;
    this.CurrentPercent = message.CurrentPercent;
    this.database_name = message.DatabaseName ? message.DatabaseName : this.database_name ;
    this.created_by = message.CreatedBy ? message.CreatedBy : this.created_by;
    this.created_date = message.CreatedDate ? message.CreatedDate : this.created_date;
    this.status = message.DatabaseStatus ? message.DatabaseStatus : this.status;
    this.UserId = message.UserId;
  },
  endMessage() {
  }
};
export const useDataManagementStore = defineStore(ModuleDataManagementList, {
  state: () => ({
    database_id: null,
    database_name: null,
    created_by: null,
    created_date: null,
    CurrentPercent: null,
    UserId: null,
    status: 3,
  }),
  actions: action,
});